<div class="step-panel">

  <div class="pg-title">
    Bureau + AA pull
    <span class="badge b-t" style="vertical-align:middle;margin-left:8px">Auto-triggered</span>
  </div>

  <!-- ══ EQUIFAX BUREAU CARD ══ -->
  <div class="card">
    <div class="card-title">
      <div class="ct-bar"></div>
      Credit Bureau — Equifax
      <span style="font-size:9.5px;color:var(--txt3);margin-left:6px" *ngIf="latestReport">
        · {{ latestReport.reportPullDate | date:'shortTime' }} IST
        · report_id: BR-0{{ latestReport.bureauReportId }}
        · source: {{ latestReport.source }}
      </span>
      <span style="font-size:9.5px;color:var(--txt3);margin-left:6px" *ngIf="!latestReport">
        · Raw hash validation complete
      </span>
    </div>

    <div class="rg4">
      <div class="rg bv">
        <div class="rg-l">Credit Score</div>
        <div class="rg-v">{{ latestSummary?.score || '—' }}</div>
        <div class="rg-s">
          {{ latestSummary?.scoreProvider || 'Equifax' }} ·
          {{ (latestSummary?.score || 0) >= 700 ? 'Good band' : 'Standard band' }}
        </div>
      </div>
      <div class="rg" [style.background]="(latestSummary?.worstDPD || 0) > 30 ? 'rgba(225,29,72,0.06)' : 'rgba(5,150,105,0.06)'">
        <div class="rg-l">DPD (Max)</div>
        <div class="rg-v" [style.color]="(latestSummary?.worstDPD || 0) > 30 ? 'var(--rose)' : 'var(--green)'">
          {{ latestSummary?.worstDPD != null ? latestSummary?.worstDPD : '—' }}
        </div>
        <div class="rg-s">Max days past due</div>
      </div>
      <div class="rg av">
        <div class="rg-l">Active Loans</div>
        <div class="rg-v">{{ latestSummary?.activeLoans != null ? latestSummary?.activeLoans : '—' }}</div>
        <div class="rg-s">Open tradelines</div>
      </div>
      <div class="rg" [style.background]="latestSummary?.writeOffFlag === 1 ? 'rgba(225,29,72,0.06)' : 'rgba(5,150,105,0.06)'">
        <div class="rg-l">Write-off</div>
        <div class="rg-v" [style.color]="latestSummary?.writeOffFlag === 1 ? 'var(--rose)' : 'var(--green)'">
          {{ latestSummary?.writeOffFlag === 1 ? 'Yes' : 'None' }}
        </div>
        <div class="rg-s">{{ latestSummary?.writeOffFlag === 1 ? '⚠ Flagged' : '✓ Clean' }}</div>
      </div>
    </div>

    <div class="tbl-wrap" style="margin-top:14px">
      <table class="tbl">
        <thead>
          <tr>
            <th>Lender</th>
            <th>Type</th>
            <th>Outstanding</th>
            <th>EMI / month</th>
            <th>DPD</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let acc of accountsList">
            <td>{{ acc.lender }}</td>
            <td>{{ acc.type }}</td>
            <td style="font-family:var(--mono);">{{ acc.outstanding | currency:'INR':'symbol':'1.0-0' }}</td>
            <td style="font-family:var(--mono);">{{ acc.emi != null ? (acc.emi | currency:'INR':'symbol':'1.0-0') : '—' }}</td>
            <td [style.color]="acc.dpd > 0 ? 'var(--rose)' : 'inherit'">{{ acc.dpd }}</td>
            <td><span class="badge" [ngClass]="acc.statusClass">{{ acc.status }}</span></td>
          </tr>
          <tr *ngIf="accountsList.length === 0">
            <td colspan="6" style="text-align:center;color:var(--txt3);padding:20px;">
              No loan accounts found in bureau report.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- ══ BANK STATEMENT — INFLOW & INCOME ══ -->
  <div class="card">
    <div class="card-title">
      <div class="ct-bar" style="background:#10b981;"></div>
      Bank Statement — Inflow &amp; Income Analysis
      <span class="ftag ft-auto" style="margin-left:4px">From Financial Profile</span>
      <span *ngIf="!hasBankStatementData"
        style="margin-left:8px;background:#fef9c3;color:#92400e;padding:2px 8px;border-radius:4px;font-size:11px;font-weight:600;">
        ⚠ Upload bank statement in Step 4 to populate
      </span>
    </div>

    <div class="rg4">
      <div class="rg gv">
        <div class="rg-l">Avg Monthly Inflow</div>
        <div class="rg-v">{{ getBSValue('BS Avg Monthly Credit', '0') | currency:'INR':'symbol':'1.0-0' }}</div>
        <div class="rg-s">Last statement period</div>
      </div>
      <div class="rg gv">
        <div class="rg-l">Total Credit</div>
        <div class="rg-v">{{ getBSValue('BS Total Credit', '0') | currency:'INR':'symbol':'1.0-0' }}</div>
        <div class="rg-s">Statement period total</div>
      </div>
      <div class="rg" [style.background]="getBSValue('BS Salary Detected','0') === '1' ? 'rgba(5,150,105,0.06)' : 'rgba(217,119,6,0.06)'">
        <div class="rg-l">Salary Detected</div>
        <div class="rg-v" [style.color]="getBSValue('BS Salary Detected','0') === '1' ? 'var(--green)' : 'var(--amber)'">
          {{ getBSValue('BS Salary Detected', '0') === '1' ? 'Yes' : 'No' }}
        </div>
        <div class="rg-s">Trust: {{ getBSValue('BS Income Trust Score', '0') }}/100</div>
      </div>
      <div class="rg bv">
        <div class="rg-l">Net Monthly Income</div>
        <div class="rg-v">{{ getBSValue('BS Net Monthly Income', '0') | currency:'INR':'symbol':'1.0-0' }}</div>
        <div class="rg-s">FOIR base</div>
      </div>
    </div>

    <div class="rg4" style="margin-top:10px">
      <div class="rg gv">
        <div class="rg-l">UPI Inflow</div>
        <div class="rg-v">{{ getBSValue('BS UPI Inflow Total', '0') | currency:'INR':'symbol':'1.0-0' }}</div>
        <div class="rg-s">{{ getBSValue('BS UPI Inflow Count', '0') }} txns</div>
      </div>
      <div class="rg gv">
        <div class="rg-l">Salary Credit</div>
        <div class="rg-v">{{ getBSValue('BS Salary Credit Amount', '0') | currency:'INR':'symbol':'1.0-0' }}</div>
        <div class="rg-s">Direct salary</div>
      </div>
      <div class="rg gv">
        <div class="rg-l">Business Receipts</div>
        <div class="rg-v">{{ getBSValue('BS Business Receipt Amount', '0') | currency:'INR':'symbol':'1.0-0' }}</div>
        <div class="rg-s">Self-employed / business</div>
      </div>
      <div class="rg" [style.background]="getBSValue('BS Income Drop 30Pct','0') === '1' ? 'rgba(225,29,72,0.06)' : ''">
        <div class="rg-l">Income Drop &gt; 30%</div>
        <div class="rg-v" [style.color]="getBSValue('BS Income Drop 30Pct','0') === '1' ? 'var(--rose)' : 'var(--green)'">
          {{ getBSValue('BS Income Drop 30Pct', '0') === '1' ? 'Yes' : 'No' }}
        </div>
        <div class="rg-s">Volatility: {{ getBSValue('BS Income Volatility Pct', '0') | number:'1.1-1' }}%</div>
      </div>
    </div>
  </div>

  <!-- ══ BANK STATEMENT — OUTFLOW & EMI ══ -->
  <div class="card">
    <div class="card-title">
      <div class="ct-bar" style="background:#f59e0b;"></div>
      Bank Statement — Outflow &amp; EMI Liability
      <span class="ftag ft-auto" style="margin-left:4px">From Financial Profile</span>
    </div>

    <div class="rg4">
      <div class="rg av">
        <div class="rg-l">Avg Monthly Outflow</div>
        <div class="rg-v">{{ getBSValue('BS Avg Monthly Debit', '0') | currency:'INR':'symbol':'1.0-0' }}</div>
        <div class="rg-s">Total: {{ getBSValue('BS Total Debit', '0') | currency:'INR':'symbol':'1.0-0' }}</div>
      </div>
      <div class="rg" [style.background]="+getBSValue('BS Existing EMI Count','0') > 0 ? 'rgba(217,119,6,0.06)' : ''">
        <div class="rg-l">Existing EMIs (detected)</div>
        <div class="rg-v">{{ getBSValue('BS Monthly EMI Amount', '0') | currency:'INR':'symbol':'1.0-0' }}</div>
        <div class="rg-s">{{ getBSValue('BS Existing EMI Count', '0') }} active loans</div>
      </div>
      <div class="rg" [style.background]="getBSValue('BS EMI Bounce Count','0') !== '0' ? 'rgba(225,29,72,0.06)' : ''">
        <div class="rg-l">EMI / Cheque Bounces</div>
        <div class="rg-v" [style.color]="getBSValue('BS EMI Bounce Count','0') !== '0' ? 'var(--rose)' : 'var(--green)'">
          {{ getBSValue('BS EMI Bounce Count', '0') }}
        </div>
        <div class="rg-s">
          Cheque: {{ getBSValue('BS Cheque Bounce Count', '0') }} ·
          NACH: {{ getBSValue('BS NACH Return Count', '0') }}
        </div>
      </div>
      <div class="rg" [style.background]="getBSValue('BS Hidden Liability Suspected','0') === '1' ? 'rgba(225,29,72,0.06)' : ''">
        <div class="rg-l">Hidden Liability</div>
        <div class="rg-v" [style.color]="getBSValue('BS Hidden Liability Suspected','0') === '1' ? 'var(--rose)' : 'var(--green)'">
          {{ getBSValue('BS Hidden Liability Suspected', '0') === '1' ? 'Suspected' : 'None' }}
        </div>
        <div class="rg-s">Stress: {{ getBSValue('BS Liability Stress Score', '0') }}/100</div>
      </div>
    </div>

    <div class="rg4" style="margin-top:10px">
      <div class="rg av">
        <div class="rg-l">ATM Withdrawals</div>
        <div class="rg-v">{{ getBSValue('BS ATM Withdrawal Amount', '0') | currency:'INR':'symbol':'1.0-0' }}</div>
        <div class="rg-s">{{ getBSValue('BS Cash Withdrawal Count', '0') }} withdrawals · {{ getBSValue('BS Cash Withdrawal Ratio Pct','0') | number:'1.1-1' }}% of debit</div>
      </div>
      <div class="rg">
        <div class="rg-l">Wallet Top-ups</div>
        <div class="rg-v">{{ getBSValue('BS Wallet Outflow', '0') | currency:'INR':'symbol':'1.0-0' }}</div>
        <div class="rg-s">Paytm: {{ getBSValue('BS Paytm Topup Count', '0') }} txns</div>
      </div>
      <div class="rg">
        <div class="rg-l">Shopping / POS</div>
        <div class="rg-v">{{ getBSValue('BS Shopping Outflow', '0') | currency:'INR':'symbol':'1.0-0' }}</div>
        <div class="rg-s">Lifestyle spend</div>
      </div>
      <div class="rg">
        <div class="rg-l">Utility / Telecom</div>
        <div class="rg-v">{{ getBSValue('BS Utility Outflow', '0') | currency:'INR':'symbol':'1.0-0' }}</div>
        <div class="rg-s">Fixed recurring</div>
      </div>
    </div>
  </div>

  <!-- ══ BANK STATEMENT — BALANCE & REPAYMENT ══ -->
  <div class="card">
    <div class="card-title">
      <div class="ct-bar" style="background:#0284c7;"></div>
      Bank Statement — Balance Health &amp; Repayment Capacity
      <span class="ftag ft-auto" style="margin-left:4px">From Financial Profile</span>
    </div>

    <div class="rg4">
      <div class="rg bv">
        <div class="rg-l">Avg Monthly Balance</div>
        <div class="rg-v">{{ getBSValue('BS Avg Monthly Balance', '0') | currency:'INR':'symbol':'1.0-0' }}</div>
        <div class="rg-s">Median: {{ getBSValue('BS Median Monthly Balance', '0') | currency:'INR':'symbol':'1.0-0' }}</div>
      </div>
      <div class="rg gv">
        <div class="rg-l">Max Balance</div>
        <div class="rg-v">{{ getBSValue('BS Maximum Balance', '0') | currency:'INR':'symbol':'1.0-0' }}</div>
        <div class="rg-s">Peak in period</div>
      </div>
      <div class="rg" [style.background]="+getBSValue('BS Minimum Balance','0') < 5000 ? 'rgba(225,29,72,0.06)' : ''">
        <div class="rg-l">Min Balance</div>
        <div class="rg-v">{{ getBSValue('BS Minimum Balance', '0') | currency:'INR':'symbol':'1.0-0' }}</div>
        <div class="rg-s">Low-balance days: {{ getBSValue('BS Low Balance Days', '0') }}</div>
      </div>
      <div class="rg" [style.background]="+getBSValue('BS Negative Balance Days','0') > 0 ? 'rgba(225,29,72,0.06)' : 'rgba(5,150,105,0.06)'">
        <div class="rg-l">Negative Days</div>
        <div class="rg-v" [style.color]="+getBSValue('BS Negative Balance Days','0') > 0 ? 'var(--rose)' : 'var(--green)'">
          {{ getBSValue('BS Negative Balance Days', '0') }}
        </div>
        <div class="rg-s">Penalty count: {{ getBSValue('BS Min Balance Penalty Count', '0') }}</div>
      </div>
    </div>

    <div class="rg4" style="margin-top:10px">
      <div class="rg" [style.background]="+getBSValue('BS Monthly Surplus','0') >= 0 ? 'rgba(5,150,105,0.06)' : 'rgba(225,29,72,0.06)'">
        <div class="rg-l">Monthly Surplus</div>
        <div class="rg-v" [style.color]="+getBSValue('BS Monthly Surplus','0') >= 0 ? 'var(--green)' : 'var(--rose)'">
          {{ getBSValue('BS Monthly Surplus', '0') | currency:'INR':'symbol':'1.0-0' }}
        </div>
        <div class="rg-s">Income/expense ratio: {{ getBSValue('BS Income Expense Ratio', '0') | number:'1.2-2' }}</div>
      </div>
      <div class="rg bv">
        <div class="rg-l">Repayment Capacity</div>
        <div class="rg-v">{{ getBSValue('BS Repayment Capacity Score', '0') }}/100</div>
        <div class="rg-s">Savings rate: {{ getBSValue('BS Savings Rate Pct', '0') | number:'1.1-1' }}%</div>
      </div>
      <div class="rg">
        <div class="rg-l">Expense Stability</div>
        <div class="rg-v">{{ getBSValue('BS Expense Stability Score', '0') }}/100</div>
        <div class="rg-s">Volatility: {{ getBSValue('BS Expense Volatility Pct', '0') | number:'1.1-1' }}%</div>
      </div>
      <div class="rg bv">
        <div class="rg-l">Cashflow Stability</div>
        <div class="rg-v">{{ getBSValue('BS Cashflow Stability Score', '0') }}</div>
        <div class="rg-s">Score</div>
      </div>
    </div>
  </div>

  <!-- ══ BANK STATEMENT — FRAUD & RISK ══ -->
  <div class="card"
    [style.border-left]="getBSValue('BS Fraud Risk Score','0') !== '0' && +getBSValue('BS Fraud Risk Score','0') > 50
      ? '4px solid var(--rose)'
      : '4px solid var(--green)'">
    <div class="card-title">
      <div class="ct-bar" [style.background]="getBSValue('BS Tampering Flagged','0') === '1' ? 'var(--rose)' : 'var(--green)'"></div>
      Bank Statement — Authenticity &amp; Fraud Signals
      <span class="ftag ft-auto" style="margin-left:4px">From Financial Profile</span>
      <span *ngIf="getBSValue('BS Tampering Flagged','0') === '1'"
        style="margin-left:8px;background:#fee2e2;color:#b91c1c;padding:3px 10px;border-radius:4px;font-size:11px;font-weight:700;">
        🚨 TAMPERING FLAGGED
      </span>
      <span *ngIf="getBSValue('BS Tampering Flagged','0') !== '1'"
        style="margin-left:8px;background:#d1fae5;color:#065f46;padding:3px 10px;border-radius:4px;font-size:11px;font-weight:700;">
        ✓ Authentic
      </span>
    </div>

    <div class="rg4">
      <div class="rg" [style.background]="getBSValue('BS Tampering Flagged','0') === '1' ? 'rgba(225,29,72,0.06)' : 'rgba(5,150,105,0.06)'">
        <div class="rg-l">File Auth Score</div>
        <div class="rg-v" [style.color]="getBSValue('BS Tampering Flagged','0') === '1' ? 'var(--rose)' : 'var(--green)'">
          {{ getBSValue('BS File Auth Score', '0') }}/100
        </div>
        <div class="rg-s">Txn Auth: {{ getBSValue('BS Txn Auth Score','0') }}/100</div>
      </div>
      <div class="rg" [style.background]="+getBSValue('BS Fraud Risk Score','0') > 50 ? 'rgba(225,29,72,0.06)' : 'rgba(5,150,105,0.06)'">
        <div class="rg-l">Fraud Risk Score</div>
        <div class="rg-v" [style.color]="+getBSValue('BS Fraud Risk Score','0') > 50 ? 'var(--rose)' : 'var(--green)'">
          {{ getBSValue('BS Fraud Risk Score', '0') }}/100
        </div>
        <div class="rg-s">{{ +getBSValue('BS Fraud Risk Score','0') > 50 ? 'High risk' : 'Low risk' }}</div>
      </div>
      <div class="rg" [style.background]="getBSValue('BS Balance Continuity Fails','0') !== '0' ? 'rgba(217,119,6,0.06)' : ''">
        <div class="rg-l">Balance Continuity Fails</div>
        <div class="rg-v" [style.color]="getBSValue('BS Balance Continuity Fails','0') !== '0' ? 'var(--amber)' : 'var(--green)'">
          {{ getBSValue('BS Balance Continuity Fails', '0') }}
        </div>
        <div class="rg-s">Duplicate txns: {{ getBSValue('BS Duplicate Txn Count', '0') }}</div>
      </div>
      <div class="rg" [style.background]="getBSValue('BS Missing Pages','0') === '1' ? 'rgba(217,119,6,0.06)' : ''">
        <div class="rg-l">Statement Integrity</div>
        <div class="rg-v" [style.color]="getBSValue('BS Missing Pages','0') === '1' ? 'var(--amber)' : 'var(--green)'">
          {{ getBSValue('BS Missing Pages','0') === '1' ? 'Incomplete' : 'Complete' }}
        </div>
        <div class="rg-s">Pages: {{ getBSValue('BS Page Count', '—') }}</div>
      </div>
    </div>

    <!-- Fraud signal tags -->
    <div style="display:flex;gap:8px;flex-wrap:wrap;margin-top:12px;">
      <span *ngIf="getBSValue('BS Suspicious Dummy Name','0') === '1'"
        style="background:#fff7ed;color:#c2410c;padding:4px 10px;border-radius:4px;font-size:12px;font-weight:600;border:1px solid #fed7aa;">
        ⚠️ Suspicious Dummy Name Transfer
      </span>
      <span *ngIf="getBSValue('BS Circular Txn Detected','0') === '1'"
        style="background:#fee2e2;color:#991b1b;padding:4px 10px;border-radius:4px;font-size:12px;font-weight:600;border:1px solid #fecaca;">
        🚨 Circular Transaction Detected
      </span>
      <span *ngIf="getBSValue('BS UPI Circular Suspected','0') === '1'"
        style="background:#fee2e2;color:#991b1b;padding:4px 10px;border-radius:4px;font-size:12px;font-weight:600;border:1px solid #fecaca;">
        🔄 UPI Circular Flow Suspected
      </span>
      <span *ngIf="+getBSValue('BS Gambling Txn Count','0') > 0"
        style="background:#fee2e2;color:#991b1b;padding:4px 10px;border-radius:4px;font-size:12px;font-weight:600;border:1px solid #fecaca;">
        🎰 Gambling: {{ getBSValue('BS Gambling Txn Count','0') }} txn(s)
      </span>
      <span *ngIf="+getBSValue('BS Crypto Txn Count','0') > 0"
        style="background:#fef3c7;color:#92400e;padding:4px 10px;border-radius:4px;font-size:12px;font-weight:600;border:1px solid #fde68a;">
        ₿ Crypto: {{ getBSValue('BS Crypto Txn Count','0') }} txn(s)
      </span>
      <span *ngIf="getBSValue('BS Artificial Balance Buildup','0') === '1'"
        style="background:#fee2e2;color:#991b1b;padding:4px 10px;border-radius:4px;font-size:12px;font-weight:600;border:1px solid #fecaca;">
        📈 Artificial Balance Build-up Suspected
      </span>
      <span *ngIf="+getBSValue('BS Frequent Loan App Txns','0') > 0"
        style="background:#fef3c7;color:#92400e;padding:4px 10px;border-radius:4px;font-size:12px;font-weight:600;border:1px solid #fde68a;">
        📱 Loan App Txns: {{ getBSValue('BS Frequent Loan App Txns','0') }}
      </span>
      <span *ngIf="!hasAnyFraudSignal()"
        style="background:#d1fae5;color:#065f46;padding:4px 10px;border-radius:4px;font-size:12px;font-weight:600;border:1px solid #a7f3d0;">
        ✓ No fraud signals detected
      </span>
    </div>
  </div>

  <!-- ══ FOIR SUMMARY ══ -->
  <div class="card">
    <div class="card-title">
      <div class="ct-bar" style="background:#6366f1;"></div>
      FOIR &amp; Loan Eligibility Summary
    </div>

    <div class="rg4">
      <div class="rg bv">
        <div class="rg-l">FOIR %</div>
        <div class="rg-v" [style.color]="+getBSValue('BS FOIR Percentage','0') > 50 ? 'var(--rose)' : 'var(--green)'">
          {{ getBSValue('BS FOIR Percentage', '0') | number:'1.1-1' }}%
        </div>
        <div class="rg-s">Risk: {{ getBSValue('BS FOIR Risk Level', '—') }}</div>
      </div>
      <div class="rg gv">
        <div class="rg-l">Net Monthly Income</div>
        <div class="rg-v">{{ getBSValue('BS Net Monthly Income', '0') | currency:'INR':'symbol':'1.0-0' }}</div>
        <div class="rg-s">FOIR base income</div>
      </div>
      <div class="rg av">
        <div class="rg-l">Total Obligation / mo</div>
        <div class="rg-v">{{ getBSValue('BS Total Monthly Obligation', '0') | currency:'INR':'symbol':'1.0-0' }}</div>
        <div class="rg-s">EMI + recurring debits</div>
      </div>
      <div class="rg bv">
        <div class="rg-l">Repayment Capacity</div>
        <div class="rg-v">{{ getBSValue('BS Repayment Capacity Score', '0') }}/100</div>
        <div class="rg-s">Score</div>
      </div>
    </div>

    <!-- Combined risk summary row -->
    <div style="margin-top:14px;padding:12px 14px;border-radius:8px;border:1px solid var(--bdr);background:var(--surf2);">
      <div style="font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:0.06em;color:var(--txt3);margin-bottom:10px;">
        Combined Risk Indicators
      </div>
      <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:10px;">
        <div class="sum-row" style="flex-direction:column;gap:2px;padding:0;border:none;">
          <span class="sk">Income Trust</span>
          <span class="sv" [style.color]="getScoreColor(+getBSValue('BS Income Trust Score','0'), 60)">
            {{ getBSValue('BS Income Trust Score', '0') }}/100
          </span>
        </div>
        <div class="sum-row" style="flex-direction:column;gap:2px;padding:0;border:none;">
          <span class="sk">Expense Stability</span>
          <span class="sv" [style.color]="getScoreColor(+getBSValue('BS Expense Stability Score','0'), 40)">
            {{ getBSValue('BS Expense Stability Score', '0') }}/100
          </span>
        </div>
        <div class="sum-row" style="flex-direction:column;gap:2px;padding:0;border:none;">
          <span class="sk">Liability Stress</span>
          <span class="sv" [style.color]="getScoreColor(100 - +getBSValue('BS Liability Stress Score','0'), 50)">
            {{ getBSValue('BS Liability Stress Score', '0') }}/100
          </span>
        </div>
        <div class="sum-row" style="flex-direction:column;gap:2px;padding:0;border:none;">
          <span class="sk">Fraud Risk</span>
          <span class="sv" [style.color]="getScoreColor(100 - +getBSValue('BS Fraud Risk Score','0'), 50)">
            {{ getBSValue('BS Fraud Risk Score', '0') }}/100
          </span>
        </div>
        <div class="sum-row" style="flex-direction:column;gap:2px;padding:0;border:none;">
          <span class="sk">Txn Auth Score</span>
          <span class="sv" [style.color]="getScoreColor(+getBSValue('BS Txn Auth Score','0'), 60)">
            {{ getBSValue('BS Txn Auth Score', '0') }}/100
          </span>
        </div>
        <div class="sum-row" style="flex-direction:column;gap:2px;padding:0;border:none;">
          <span class="sk">Cash Heavy</span>
          <span class="sv" [style.color]="getBSValue('BS Cash Heavy Profile','0') === '1' ? 'var(--amber)' : 'var(--green)'">
            {{ getBSValue('BS Cash Heavy Profile', '0') === '1' ? 'Yes' : 'No' }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- ══ NAVIGATION ══ -->
  <div class="nav-bar">
    <button class="btn btn-sec" (click)="prev.emit()" [disabled]="isLoading">← Back</button>
    <button class="btn btn-pri btn-lg" (click)="proceed()" [disabled]="isLoading">
      <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2" role="status"></span>
      Next →
    </button>
  </div>

</div>